import { render } from "./SeparatorTestData.vue?vue&type=template&id=f41654c0"
import script from "./SeparatorTestData.vue?vue&type=script&lang=js"
export * from "./SeparatorTestData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__